import React from 'react';
import { Avatar, Card, CardText } from 'material-ui';
import { connect } from 'react-redux';
import { Form, FormError } from 'react-form';
import _ from 'lodash';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import Translate from 'translate';

import SimplePanel from 'components/HTMLElements/Panel/Simple/';
import AutomaticResponsesBtn from 'routes/app/components/Agent/AutomaticResponsesBtn/';
import ChannelOperationService from 'services/ChannelOperationService';
import ChannelService from 'services/ChannelService';
import AuthService from 'services/AuthService';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import { Checkbox, FormGroup, Select, Textarea } from 'components/FormElements';
import { required } from 'constants/InputErrors';
import DeleteModal from "components/HTMLElements/DeleteModal";
import DismissModal from "components/HTMLElements/DismissModal";
import checkbox from "assets/images/checkbox.svg";

class ChannelsAssign extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      replyEnabled: false,
      dismissModalOpened: false,
    };

    this.submitAssign = this.submitAssign.bind( this );
    this.submitReply = this.submitReply.bind( this );
    this.toggleReply = this.toggleReply.bind( this );
    this.toggleDismissModal = this.toggleDismissModal.bind( this );
    this.dismissMessages = this.dismissMessages.bind( this );
  }

  submitAssign( formData ) {
    const { data, onClear, onReloadData, toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    ChannelService.assignChannels( {
      ...formData,
      channels: _.map( data, 'id' ),
      categories: _.map( formData.categories, 'id' ),
    } ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) return toggleAlertError( response.errors );

      onReloadData();
      onClear();

    } )
  }

  submitReply( formData ) {
    const { data, onClear, onReloadData, toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    ChannelOperationService.saveMessages( {
      channels: _.map( data, 'id' ),
      content: formData.content,
      closeChannels: formData.closeChannels ? true : undefined,
    } ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) return toggleAlertError( response.errors );

      if ( (response.data) && (response.data.result === false ) ) {
        toggleAlertError( response.data.message );
      }
      onReloadData();
      onClear();
 
    } )
  }


  toggleReply() {
    this.setState( { replyEnabled: !this.state.replyEnabled } )
  }

  toggleDismissModal() {
    this.setState( { dismissModalOpened: !this.state.dismissModalOpened } )
  }

  dismissMessages(reason) {
    const { data, toggleAlertError, toggleLoading, onClear, onReloadData } = this.props;
    toggleLoading( true );

    ChannelService.dismissChannels( {
      channels: _.map( data, 'id' ),description :reason.reason
    } ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );
      if ( (response.data) && (response.data.result === false ) ) {
        toggleAlertError( response.data.message );
      }
      onReloadData();
      onClear();
    } )
  }

  render() {
    const { data, onToggle, onClear, options, intl, onReloadData } = this.props;
    const highTone = _.find( options.tones, { tone: 'HIGH', active: true } );
    const lowTone = _.find( options.tones, { tone: 'LOW', active: true } );
    const neutralTone = _.find( options.tones, { tone: 'NEUTRAL', active: true } );

    return (
      <SimplePanel className="m-0" contentClassName="pt-0 box-unload-channel">
        <div className="box-center-selectable col-md-12 px-1">
          <div className="row">
            {_.map( data, ( item, index ) =>
              <div key={index} className="col-md-4 mt-4">
                <Card containerStyle={{ paddingBottom: 0 }}>
                  <CardText
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: 10
                    }}>
                    <Avatar src={_.get( item, 'webPathThumbnail' )}/>
                    <span className="ml-1">{_.get( item, 'name' )}</span>
                    <i className="fa fa-close pointer"
                       onClick={() => onToggle( item, false )}/>
                  </CardText>
                </Card>
              </div> )}
          </div>
        </div>

        <div className="d-flex justify-content-between border-top border-secondary">
          {!this.state.replyEnabled ?
            <button className="btn my-4 btn-secondary" onClick={this.toggleDismissModal}>
              <Translate id="dismissMessages"/>
            </button> : <div/>}
          {this.props.type !== 'chat' &&
          <button className={classNames( 'btn my-4', {
            'btn-secondary': this.state.replyEnabled,
            'btn-outline-secondary': !this.state.replyEnabled,
          } )} onClick={this.toggleReply}><Translate id="toggleMessage"/>
          </button>
          }
        </div>

        {this.state.replyEnabled ?
          <Form
            onSubmit={this.submitReply}
            validate={( values ) => {
              return {
                content: required( values.content ),
              }
            }}>
            {( { setValue, submitForm } ) =>
              <form onSubmit={submitForm}>
                <div className="d-flex justify-content-between">
                  <Checkbox field="closeChannels"
                            label={intl.formatMessage( { id: "closeChannels" } )}
                            uncheckedIcon={<div style={{paddingLeft: 3}}><img src={checkbox}/></div>}
                            labelStyle={{width: 'auto'}}
                  />
                  <AutomaticResponsesBtn options={options.responses}
                                         onClickResponse={( value ) => setValue( 'content', value )}
                  />
                </div>

                <FormGroup>
                  <Textarea field="content" className="form-control" rows={4}/>
                </FormGroup>

                <div className="row">
                  <div className="col-md-6">
                    <button className="btn btn-secondary px-4" type="button" onClick={onClear}>
                      <Translate id="clear"/></button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button className="btn btn-info px-4" type="submit"><Translate id="notify"/>
                    </button>
                  </div>
                </div>
              </form>
            }
          </Form>
          :
          <Form
            onSubmit={this.submitAssign}
            validate={( values ) => {
              return {
                required: !values.categories && !values.user && !values.userGroup ?
                  <Translate id="selectCatUserGroup"/> : null,
              }
            }}>
            {( { getValue, setValue, submitForm } ) =>
              <form onSubmit={submitForm}>
                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <Checkbox field="important" label={<Translate id="markAsImportant"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                  </FormGroup>

                  <div className="col-md-6">
                    {!!highTone &&
                    <img onClick={() => setValue( 'tone', highTone.id )} width={26}
                         src={getValue( 'tone' ) === highTone.id ? 'assets/images/icons/thumb-up.png' : 'assets/images/icons/thumb-up-o.png'}/>
                    }
                    {!!neutralTone &&
                    <img className="mx-2" onClick={() => setValue( 'tone', neutralTone.id )} width={28}
                         src={getValue( 'tone' ) === neutralTone.id ? 'assets/images/icons/point-at.png' : 'assets/images/icons/point-at-o.png'}/>
                    }
                    {!!lowTone &&
                    <img onClick={() => setValue( 'tone', lowTone.id )} width={26}
                         src={getValue( 'tone' ) === lowTone.id ? 'assets/images/icons/thumb-down.png' : 'assets/images/icons/thumb-down-o.png'}/>
                    }
                  </div>
                </div>

                <FormGroup>
                  <Select field="service" className="form-control"
                          placeholder={intl.formatMessage( { id: "selectService" } )}
                          options={options.services} labelKey="service"/>
                </FormGroup>

                <FormGroup>
                  <Select field="categories" className="form-control"
                          placeholder={intl.formatMessage( { id: "selectCategories" } )}
                          labelKey="category"
                          simpleValue={false} multi options={options.categories}/>
                </FormGroup>

                {options.users && (!AuthService.getUserRole().isOperator || data.length === 1) &&
                <FormGroup>
                  <Select field="user" className="form-control"
                          placeholder={intl.formatMessage( { id: "selectUser" } )}
                          options={options.users}/>
                </FormGroup>
                }

                {options.groups &&
                <FormGroup>
                  <Select field="userGroup" className="form-control"
                          placeholder={intl.formatMessage( { id: "selectUserGroup" } )}
                          options={options.groups}/>
                </FormGroup>
                }
                <FormGroup containerClass="col-md-12">
                  <div className="FormInput -hasError">
                    <FormError field="required"/>
                  </div>
                </FormGroup>

                <div className="row">
                  <div className="col-md-6">
                    <button className="btn btn-secondary px-4" type="button" onClick={onClear}>
                      <Translate id="clear"/></button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button className="btn btn-info px-4" type="submit"><Translate id="assign"/>
                    </button>
                  </div>
                </div>
              </form>
            }
          </Form>
        }

        <DismissModal label={<Translate id="youSureDismissMessages"/>}
                    isDismiss={true}
                     onConfirm={this.dismissMessages}
                     opened={this.state.dismissModalOpened}
                     onToggle={this.toggleDismissModal}
        />

      </SimplePanel>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( injectIntl( ChannelsAssign ) );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChannelsAssign/index.js